import { useSelector } from 'react-redux';
import { ValidationStatus } from 'signup-ui-lego-core/types';
import { getStepData } from '../step/getStepData';
import { getSignupDataValidations } from '../store/signup-data/selectors';
export const useIsStepDataValid = currentStep => {
  const dataPoints = getStepData(currentStep);
  const validationStatuses = useSelector(state => getSignupDataValidations(state, dataPoints));
  return validationStatuses.every(value => value === ValidationStatus.VALID);
};
export const useIsDataPointValid = dataPoints => {
  const validationStatuses = useSelector(state => getSignupDataValidations(state, dataPoints));
  return validationStatuses.every(value => value === ValidationStatus.VALID);
};